import { HelpSupportPanelProps } from '@pushpay/shell/lib/types/components/help-support-panel/types'; // Platforms version of Typescript doesn't support type exports

import { SalesforceChatConfigSettings } from '../loggedinweb-generated';


export function getHelpSupportPanelProps(salesforceChatConfig: SalesforceChatConfigSettings | null): HelpSupportPanelProps {
    const supportPanelProps: HelpSupportPanelProps = {
        helpLabel: 'Help & Support',
        dividerLabel: 'or',
        search: {
            placeHolderText: 'Search help center...',
            onSearch: (searchTerm: string) => {
                window.open(`https://care.pushpay.com/s/global-search/${encodeURIComponent(searchTerm)}`, '_blank');
            },
        },
        sections: [{
            title: 'Help & Support',
            items: [
                {
                    type: 'help-center',
                    title: 'Help Center',
                    description: 'Guides, advanced help, and more',
                    href: 'https://support.pushpay.com/s/get-help',
                },
                {
					type: 'product-releases',
					title: 'Product Releases',
					description: `See what's new`,
					href: 'https://pushpay.com/product/releases',
				},
				{
					type: 'resource-center',
					title: 'Resource Center',
					description: 'Onboarding',
				},
				{
					type: 'pushpay-university',
					title: 'Pushpay University',
					description: 'Live and on demand training',
					href: 'https://pushpayuniversity.com/?utm_campaign=giving_help',
				},
				{
					type: 'webinars',
					title: 'Webinars',
					description: 'Sign up to attend free weekly training webinars',
					href: 'https://www.pushpayuniversity.com/calendar?utm_campaign=giving_help',
				},
            ],
        }],        
    }

    if (!salesforceChatConfig) return supportPanelProps; 

    const { DeploymentName, OrgId, ScriptUrl, Scrt2Url, SiteUrl } = salesforceChatConfig;
    return {
        ...supportPanelProps,
        chat: {
            title: 'Ask Genny',
            description: 'Your AI assistant for quick answers about Pushpay products',
            config: {
                deploymentName: DeploymentName,
                orgId: OrgId,
                scriptUrl: ScriptUrl,
                siteUrl: SiteUrl,
                scrt2Url: Scrt2Url,
            },
        },
    }
}